module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Meetup guidelines","pageDesc":"Read our guidelines for a better experience in every Baianat meetup.","mantra":"Our Meetup |guidelines."},"ar":{"pageTitle":"إرشادات ملتقيات بيانات","pageDesc":"تعرف على إرشادات ملتقيات بيانات لكي تحصل على تجربة أفضل في كل لقاء ندعو إليه.","mantra":"إرشادات الملتقيات| لدينا."}}')
  delete Component.options._Ctor
}
